<template>
  <CardModule title="Regra de Comissão" class="mt-6">
    <v-row>
      <v-col cols="6">
        <BaseSelect
          label="Comissão do Ponto de Venda"
          placeholder="Selecione uma regra de comissão"
          item-text="text"
          item-value="value"
          hide-details
          :items="comissoes"
          v-model="$pointOfSale.cadastro.comissao_antecipacao.comissao"
          :error-messages="
            $pointOfSale.cadastro.comissao_antecipacao.error.comissao
          "
          @input="
            $pointOfSale.cadastro.comissao_antecipacao.error.comissao = []
          "
        />
      </v-col>
      <v-col cols="6">
        <BaseTextField
          label="Porcentagem personalizada"
          placeholder="0"
          hide-details
          type="number"
          min="0"
          :disabled="!isCustomComission"
          v-model="
            $pointOfSale.cadastro.comissao_antecipacao.porcentagem_customizada
          "
          :error-messages="
            $pointOfSale.cadastro.comissao_antecipacao.error
              .porcentagem_customizada
          "
          @input="
            $pointOfSale.cadastro.comissao_antecipacao.error.porcentagem_customizada =
              []
          "
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <BaseTextarea
          label="Observações sobre a negociação"
          placeholder="Digite aqui as observações sobre a negociação"
          v-model="$pointOfSale.cadastro.comissao_antecipacao.observacoes"
        />
      </v-col>
    </v-row>
  </CardModule>
</template>
<script>
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextarea from "@/components/forms/BaseTextarea.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import PDVmixins from "@/mixins/PDV.mixins.js";
export default {
  name: "Comission",
  mixins: [PDVmixins],
  components: {
    CardModule,
    BaseTextarea,
    BaseTextField,
    BaseSelect,
  },
  computed: {
    isCustomComission() {
      return this.$pointOfSale.cadastro.comissao_antecipacao.comissao === "1";
    },
  },
  watch: {
    "$pointOfSale.cadastro.comissao_antecipacao.comissao": function (e) {
      if (e == "3") {
        this.$pointOfSale.cadastro.comissao_antecipacao.porcentagem_customizada = 0;
      }
    },
  },
};
</script>
<style scoped></style>
